<template>
  <div class="product">
    <navBar />
    <div class="p-banner" />
    <div class="p-title">
      <img class="p-header" src="https://restaskimg.civaonline.cn/imagesH5/product/header.png" alt="">
      <div class="p-title-r">
        <div class="p-title-txt">
          双师课堂
        </div>
        <div class="p-title-intro">
          名师与你零距离，教学提升更容易
        </div>
      </div>
    </div>
    <div class="p-content">
      <div class="p-content-item p-item-1">
        <img class="item-img-1" src="https://restaskimg.civaonline.cn/imagesH5/double-1.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-1">
            <span>双师授课</span>
          </h4>
          <p class="p-item-text-intro">
            双师课程直接用于授课，解决教师短缺下学生授课问题。 主讲老师与辅导老师相互配合，教与学明确分工，提升教学效率和学生的学习效果
          </p>
        </div>
      </div>
      <div class="p-content-item p-item-2">
        <img class="item-img-2" src="https://restaskimg.civaonline.cn/imagesH5/double-2.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-1">
            <span>辅导答疑</span>
          </h4>
          <p class="p-item-text-intro">
            辅导老师全程关注，监督落实学习效果
            课前与主讲老师研讨课程，完成备课；课中配合主讲老师管理课堂，及时答疑解惑；课后布置落实作业，点评批改，跟踪学习情况
          </p>
        </div>
      </div>
      <div class="p-content-item p-item-3">
        <img class="item-img-3" src="https://restaskimg.civaonline.cn/imagesH5/double-3.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-1">
            <span>启发互动</span>
          </h4>
          <p class="p-item-text-intro">
            设置提问互动、游戏环节，提高学生注意力，引发学生思考，形成教学闭环
            辅导老师配合主讲老师完成课上的互动、抢答、出门考、做任务等环节
          </p>
        </div>
      </div>
      <div class="p-content-item p-item-4">
        <img class="item-img-4" src="https://restaskimg.civaonline.cn/imagesH5/double-4.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-1">
            <span>教学支撑</span>
          </h4>
          <p class="p-item-text-intro">
            辅导机构教师进行授课，促进辅导教师成长，有效提升教师教学实施能力
            线上主辅备课，教学横版，说课视频，授课教辅资料，支撑充分
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
}
</script>

<style scoped lang="less">
    .product{
        .p-banner{
            background: url("https://restaskimg.civaonline.cn/imagesH5/d-banner.png") no-repeat center center / cover;
        }
        .p-content{
            padding: 0 32px 112px;
            .p-content-item{
                background: rgba(255,171,178,0.15);
                padding-bottom: 40px;
                margin-top: 210px;
                img{
                    width: 640px;
                    margin-top: -130px;
                }
                .p-item-text{
                    margin-top: 30px;
                    .p-item-text-title:before{
                        background: rgba(253,185,170,1);
                    }
                    .line-1:before{
                        width: 128px;
                    }
                    .p-item-text-intro{
                        text-align: left;
                        padding: 0 32px;
                    }
                }
            }
        }
    }
</style>
